import { render } from "./NewsManagement.vue?vue&type=template&id=7e336dff&scoped=true"
import script from "./NewsManagement.vue?vue&type=script&lang=js"
export * from "./NewsManagement.vue?vue&type=script&lang=js"

import "./NewsManagement.vue?vue&type=style&index=0&id=7e336dff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e336dff"]])

export default __exports__